import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MSG_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Init Firebase \\
firebase.initializeApp(firebaseConfig);

// Init Services \\
const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth();

// Timestamp \\
const timestamp = firebase.firestore.Timestamp;

export { projectFirestore, projectAuth, timestamp };
